import React from "react";

/**
 * A type-categorized section header (emoji + uppercase label) with children.
 */
export function TypeSection({
  emoji,
  label,
  children,
}: {
  emoji: string;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="mt-3 first:mt-0">
      <div className="flex items-center gap-1.5 mb-0.5">
        <span className="text-sm">{emoji}</span>
        <span className="text-xs font-medium text-term-text-dim uppercase tracking-wide">
          {label}
        </span>
      </div>
      {children}
    </div>
  );
}
